import { Pagination } from 'antd';
export default function TablePagination({...props}){
    return <Pagination
        {...props}
    />
}